import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'

export const useTeamLogos = () => {
  const { theme } = useTheme()

  const isDarkMode = computed(() => {
    if (theme.value === 'dark') return true
    if (theme.value === 'light') return false
    
    // System default - check actual applied theme
    return document.documentElement.classList.contains('dark')
  })

  const getTeamLogoUrl = (teamAbbreviation: string): string => {
    const logoTheme = isDarkMode.value ? 'dark' : 'light'
    return `/logos/${teamAbbreviation.toUpperCase()}_${logoTheme}.svg`
  }

  return {
    getTeamLogoUrl,
    isDarkMode
  }
}